import PageWrapper from '@srm/ui/page-wrapper';
import PageHero from '@srm/ui/page-hero';
import Skeleton from '@srm/ui/skeleton';
import DataTableSkeleton from '@srm/ui/data-table/skeleton';
import { MdOutlineNotifications } from 'react-icons/md';
import '../Notification.scss';
import './NotificationSkeleton.scss';

export const NotificationPageHeader = ({ animateIcon = false }: { animateIcon?: boolean }) => (
    <PageHero
        animated={animateIcon}
        icon={<MdOutlineNotifications />}
        title="Уведомления"
        subtitle="Сообщения о событиях и изменениях в системе"
    />
);

const NotificationSkeleton = () => (
    <PageWrapper title={<NotificationPageHeader />} className="notification-page" contentSurface>
        <div className="notification-skeleton" role="status" aria-label="Загрузка уведомлений" aria-busy="true">
            <div className="notification-skeleton__list">
                <DataTableSkeleton fillHeight paging={false} />
            </div>
            <div className="notification-skeleton__detail" aria-hidden>
                <Skeleton height={18} width="60%" radius={6} />
                <Skeleton height={12} width="35%" radius={5} />
                <Skeleton height={60} radius={8} />
            </div>
        </div>
    </PageWrapper>
);

export default NotificationSkeleton;
